var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["CLEARED"] = "CLEARED";
    Status["FAILED"] = "FAILED";
    Status["CANCELLED"] = "CANCELLED";
    Status["SPENT"] = "SPENT";
    Status["REFUND_SPENT"] = "REFUND_SPENT";
})(Status || (Status = {}));
export default Status;
